.root {
  width: var(--sidebar-width);
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 14px;
  background: var(--color-surface-subtle);
  border-right: 1px solid var(--color-border);
  overflow-y: auto;
}

.groups {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.groupTitle {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-tertiary);
  padding: 0 10px;
}

.items {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.scrim {
  display: none;
}

@media (max-width: 720px) {
  .root {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 40;
    transform: translateX(-100%);
    transition: transform var(--duration-medium) var(--ease-standard);
    box-shadow: var(--shadow-lg);
    padding-top: calc(var(--header-height) + 12px);
  }

  .open {
    transform: translateX(0);
  }

  .scrim {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(11, 37, 69, 0.32);
    z-index: 30;
  }
}
